<template>
    <div>
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="_save()">添加</el-button>
        <el-table v-loading="datas.status == -1" :data="datas.data" @sort-change="_sort" @selection-change="_select">
            <el-table-column width="150" align="center" fixed label="操作">
                <template slot-scope="scope">
                    <div class="handle-box">
                        <el-button type="text" @click="_save(scope.row.id)">编辑</el-button>
                        <el-button type="text" @click="_del(scope.row.id)" class="c-danger">删除</el-button>
                    </div>
                </template>
            </el-table-column>
            <template v-for="(item, index) in mix_fields">
                <el-table-column :label="item.COLUMN_COMMENT" :width="item.width ? item.width : 'auto'" :key="index">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row[item.COLUMN_NAME] }}
                        </div>
                    </template>
                </el-table-column>
            </template>
        </el-table>


        <div class="page-box">
            <el-pagination @size-change="_size" @current-change="_page" :current-page="datas.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="datas.limit" layout="total, sizes, prev, pager, next"
                :total="datas.total">
            </el-pagination>
        </div>


        <ls-table-data :table="table" @fields="e => { mix_fields = e }"></ls-table-data>
        <ls-mask v-if="show_save" @close="show_save = false" :title="r.id ? '编辑' : '新增'" width="600px">
            <el-form>
                <el-form-item label="投标单位">
                    <el-input v-model="r.title"></el-input>
                </el-form-item>
                <el-form-item label="预算费/元">
                    <el-input v-model="r.ysf"></el-input>
                </el-form-item>
                <el-form-item label="是否中标">
                    <el-switch v-model="r.is_zb" :active-value="1" :inactive-value="0">
                    </el-switch>
                </el-form-item>
                <el-form-item label="提成-造价员" v-if="_is_show_group(9)">
                    <el-input v-model="r.comm_zj"></el-input>
                </el-form-item>
                <el-form-item label="投标保证金缴纳方式">
                    <el-input v-model="r.bzj_way"></el-input>
                </el-form-item>
                <el-form-item label="投标保证金缴纳时间">
                    <el-date-picker type="date" v-model="r.date_bzj" align="center" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="投标保证金退还时间">
                    <el-date-picker type="date" v-model="r.date_bzj_th" align="center" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="标书费/元">
                    <el-input v-model="r.bsf"></el-input>
                </el-form-item>
                <el-form-item label="提成-标书员" v-if="_is_show_group(7)">
                    <el-input v-model="r.comm_bs"></el-input>
                </el-form-item>
                <el-form-item label="招标文件">
                    <div v-if="vuex_admin.admin_group_id == 8">
                        <div class="files">
                            <div v-for="(item, index) in r.zb_files" :key="index">
                                {{ item.file_name }}
                                <a :href="item.url" target="_blank">查看/下载</a>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <ls-upload-files v-model="r.zb_files"></ls-upload-files>
                    </div>
                </el-form-item>
                <el-form-item label="预算信息">
                    <div v-if="vuex_admin.admin_group_id == 8">
                        <div class="files">
                            <div v-for="(item, index) in r.ys_files" :key="index">
                                {{ item.file_name }}
                                <a :href="item.url" target="_blank">查看/下载</a>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <ls-upload-files v-model="r.ys_files"></ls-upload-files>
                    </div>
                </el-form-item>
                <el-form-item label="投标文件">
                    <div v-if="vuex_admin.admin_group_id == 8">
                        <div class="files">
                            <div v-for="(item, index) in r.tb_files" :key="index">
                                {{ item.file_name }}
                                <a :href="item.url" target="_blank">查看/下载</a>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <ls-upload-files v-model="r.tb_files"></ls-upload-files>
                    </div>
                </el-form-item>
                <el-form-item label="预算文件">
                    <div v-if="vuex_admin.admin_group_id == 6">
                        <div class="files">
                            <div v-for="(item, index) in r.yss_files" :key="index">
                                {{ item.file_name }}
                                <a :href="item.url" target="_blank">查看/下载</a>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <ls-upload-files v-model="r.yss_files"></ls-upload-files>
                    </div>
                </el-form-item>
                <el-form-item label="专家检查意见">
                    <div v-if="vuex_admin.admin_group_id == 8">
                        <div class="files">
                            <div v-for="(item, index) in r.files" :key="index" v-if="item.field == 'yj'">
                                {{ item.file_name }}
                                <a :href="item.url" target="_blank">查看/下载</a>
                            </div>
                        </div>
                    </div>
                    <div v-else>

                        <ls-upload-files v-model="r.files" field="yj"></ls-upload-files>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="_submit">提交</el-button>
                </el-form-item>
            </el-form>
        </ls-mask>
    </div>
</template>
<script>
export default {
    props: {
        info_id: {
            default: 0
        }
    },
    data() {
        return {
            table: 'info_tb',
            datas: {
                add: {
                    info_id: this.info_id
                }
            },
            r_add: {
                info_id: this.info_id
            }
        };
    },
    created() {
        this._load();
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>